import * as React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { useUndeleteBoard } from '../hooks/useUndeleteBoard'

interface ManageBoardDeletionStatusProps {
  boardId: string
  onClose: () => any
}

export const ManageBoardDeletionStatus: React.FC<ManageBoardDeletionStatusProps> = props => {
  const [mutate, { loading }] = useUndeleteBoard()
  const [modalOpen, setModalOpen] = React.useState(false)

  const perform = async () => {
    if (loading) return
    await mutate({
      variables: {
        boardId: props.boardId
      }
    })
    setModalOpen(false)
    props.onClose()
  }

  return (
    <>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>Undelete a Vestaboard</DialogTitle>
        <DialogContent dividers>Are you sure you would like to undelete the Vestaboard?</DialogContent>
        <DialogActions>
          <Button variant='contained' color='primary' disabled={loading} onClick={() => perform()}>
            Yes
          </Button>
          <Button onClick={() => setModalOpen(false)}>No</Button>
        </DialogActions>
      </Dialog>
      <Button variant='outlined' onClick={() => setModalOpen(true)}>
        Undelete
      </Button>
    </>
  )
}
